export default {
  allPartners(state) {
    return state.partners;
  },
  selectedPartner(state) {
    return state.partner;
  },
  commonData(state, getters) {
    return state.commonData;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/partners/getters.js